import {createContext} from "react";
export const linkContext = createContext(null);
